<!--created @daniel.silva 2020.07.05 Eletronic Invoice Alert Component-->
<template>
    <v-dialog v-model="enabled" max-width="295" persistent light>
        <v-card>
            <v-card-title class="title text-no-wrap" style="font-size: 19px !important;font-weight: bold;">
                {{header_text}}
            </v-card-title>
            <v-card-text class="body-1">{{body_text}}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat="flat" @click="cancelInvoiceSubscribe()">
                    {{cancel_text}}
                </v-btn>
                <v-btn color="primary" @click="goUser()">
                    {{ok_text}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "EInvoice",
        props: {
            enabled: Boolean
        },
        data() {
            return {
                enabledClone: this.enabled,
                //TODO Parametrizar estes textos
                header_text: "Adira à factura sem papel",
                body_text: "Poupe o ambiente e ganhe 5 pontos",
                cancel_text: "Agora não",
                ok_text: "Aderir",
            }
        },
        methods: {
            goUser() {
                this.$router.push({name: "user"});
            },
            cancelInvoiceSubscribe() {
                this.enabledClone = false;
            },
        },
        watch: {
            enabled() {
                this.enabledClone = this.enabled
            },
            enabledClone() {
                if (this.enabledClone !== this.enabled) {
                    this.$emit('changeEinvoiceAlert', this.enabledClone);
                }
            }
        },

    }
</script>

<style scoped>

</style>